import { BRAND_KIT_SETUP_TOOL_NAME } from './brandKitSetup';
import { DETECT_TEXT_TOOL_NAME } from './detectText';
import { ELICIT_MISSING_CONTEXT_TOOL_NAME } from './elicitMissingContext';
import { FILE_EDIT_COMPLETE_TOOL_NAME } from './fileEditComplete';
import { GENERATE_TEXT_TOOL_NAME } from './generateText';
import { SUBMIT_TRANSLATIONS_TOOL_NAME } from './submitTranslations';

export const DEFAULT_TOOL_DESCRIPTION = 'Running tool';

const TOOL_DESCRIPTIONS_KEYS = [
  'add_border',
  'adjust_image',
  'ai_image',
  'ai_video',
  'apply_effect',
  'apply_filter',
  'blend_images',
  BRAND_KIT_SETUP_TOOL_NAME,
  'collage_layout',
  'composite_images',
  'create_solid_image',
  'crop_image',
  'draw_shapes',
  ELICIT_MISSING_CONTEXT_TOOL_NAME,
  FILE_EDIT_COMPLETE_TOOL_NAME,
  GENERATE_TEXT_TOOL_NAME,
  'get_ai_model_schema',
  'load_media',
  'replace_image_text',
  'request_for_information',
  'resize_image',
  'rotate_image',
  'smart_resize',
  DETECT_TEXT_TOOL_NAME,
  SUBMIT_TRANSLATIONS_TOOL_NAME,
  'upload_media',
  'view_image',
] as const;

type ToolName = (typeof TOOL_DESCRIPTIONS_KEYS)[number];

const toolDescriptions = new Map<ToolName, string>([
  ['add_border', 'Adding border'],
  ['adjust_image', 'Adjusting image'],
  ['ai_image', 'Running AI operation'],
  ['ai_video', 'Generating video'],
  ['apply_effect', 'Applying effect'],
  ['apply_filter', 'Applying filter'],
  ['blend_images', 'Blending images'],
  [BRAND_KIT_SETUP_TOOL_NAME, 'Preparing Brand Kit setup'],
  ['collage_layout', 'Arranging collage'],
  ['composite_images', 'Compositing images'],
  ['create_solid_image', 'Creating solid color image'],
  ['crop_image', 'Cropping image'],
  ['draw_shapes', 'Drawing shapes'],
  [ELICIT_MISSING_CONTEXT_TOOL_NAME, 'Looking for brand assets'],
  [FILE_EDIT_COMPLETE_TOOL_NAME, 'Showing edit'],
  [GENERATE_TEXT_TOOL_NAME, 'Generating text'],
  ['get_ai_model_schema', 'Loading model parameters'],
  ['load_media', 'Loading media'],
  ['replace_image_text', 'Replacing text'],
  ['request_for_information', 'Requesting information'],
  ['resize_image', 'Resizing image'],
  ['rotate_image', 'Rotating image'],
  ['smart_resize', 'Generating variants'],
  [DETECT_TEXT_TOOL_NAME, 'Detecting text'],
  [SUBMIT_TRANSLATIONS_TOOL_NAME, 'Translating text'],
  ['upload_media', 'Uploading media'],
  ['view_image', 'Viewing image'],
]);

export const TOOL_DESCRIPTIONS: ReadonlyMap<string, string> = toolDescriptions;

export const SUBSCRIBED_TOOLS = Array.from(toolDescriptions.entries()).map(([tool, description]) => ({
  description,
  name: tool,
  parameters: undefined,
}));
